<template>
  <tg-layout :headerHeight="120">
    <template slot="header">
      <TgSearchTool @on-submit="clickToSearch">
        <TgDateSearch
          ref="dateSearch"
          size="small"
          v-model="dateRange"
          showDateRangePicker
          twoMonthLimit
          isAccountDate
        ></TgDateSearch>
      </TgSearchTool>
      <el-row style="padding: 5px">
        <!-- 平台選擇按鈕 -->
        <thirdPartySearchBtn
          style="display: initial"
          @click.native="showThirdPartyCheckBoxDialog"
        ></thirdPartySearchBtn>
        <ThirdPartyPlatform
          v-model="thirdPartyData"
          @on-change="handleSearchThirdParty"
        ></ThirdPartyPlatform>
      </el-row>
    </template>
    <TgTable
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
      :summary-method="parsePageSummary"
      showSummary
    >
      <template slot="userfullname" slot-scope="scope">
        {{ scope.row.username }}
      </template>

      <!-- 單號 -->
      <template slot="betId" slot-scope="scope">
        <tg-bet-id :row="scope.row"></tg-bet-id>
      </template>

      <!-- IP -->
      <template slot="deviceInfo" slot-scope="scope">
        <span>{{ scope.row.ip }}</span
        >
      </template>

      <!-- 平台 -->
      <template slot="source_type" slot-scope="scope">
        <span :class="['text-' + scope.row.source_type]">
          {{ $t("component.label.source_type." + scope.row.source_type) }}
        </span>
      </template>

      <!-- 投注內容 -->
      <template slot="betContent" slot-scope="scope">
        <TgBetContent
          v-if="scope.row.source_type == 'tg'"
          :row="formatBetContent(scope.row)"
        ></TgBetContent>
        <ThirdPartySabaBetContent
          v-else-if="
            ((scope.row.source_type == 'saba' ||
              scope.row.source_type == 'sabawhite_sport') &&
              (scope.row.content_type == 2 || scope.row.content_type == 5)) ||
            (scope.row.source_type.includes('sport') &&
              scope.row.serial_type == 1) //serial_type == 1 非串關
          "
          :row="formatBetContent(scope.row)"
        ></ThirdPartySabaBetContent>
        <ThirdPartySabaParlayBetContent
          v-else-if="
            (scope.row.source_type == 'saba' ||
              scope.row.source_type == 'sabawhite_sport') &&
            (scope.row.content_type == 3 || scope.row.content_type == 4)
          "
          :row="formatBetContent(scope.row)"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></ThirdPartySabaParlayBetContent>
        <ThirdPartySabaParlayBetContent
          v-else-if="
            scope.row.source_type != 'saba' &&
            scope.row.source_type.includes('sport')
          "
          :row="formatBetContent(scope.row)"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></ThirdPartySabaParlayBetContent>
        <ThirdPartyPublicBetContent
          v-else
          :row="formatBetContent(scope.row)"
        ></ThirdPartyPublicBetContent>
      </template>

      <!-- 注單結果 -->
      <template slot="after" slot-scope="scope">
        <div
          :class="{
            'text-red': scope.row.after < 0,
            'text-green': scope.row.after > 0,
          }"
        >
          {{ scope.row.after }}
        </div>
      </template>

      <!-- 備註 -->
      <template slot="note_txt" slot-scope="scope">
        {{ scope.row.note_txt }}
      </template>
    </TgTable>

    <!-- 平台篩選彈窗 -->
    <ThirdPartyCheckBoxDialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="thirdPartyData"
      @on-click="handleSearchThirdParty"
    ></ThirdPartyCheckBoxDialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgTable from "@/components/table/TgTable";
import TgBetContent from "@/components/slot/TgBetContent";
import ThirdPartyPublicBetContent from "@/components/slot/ThirdPartyPublicBetContent";
import ThirdPartySabaBetContent from "@/components/slot/ThirdPartySabaBetContent";
import TgBetId from "@/components/slot/TgBetId";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from "@/components/tool/ThirdPartyPlatform";
import { summary } from "@/utils/table";
import { sabaParlayHandler } from "@/mixins/betContent";
import { thirdPartyCheckBoxDialogHandler } from "@/mixins/third_party/dialog";

import apis from "@/apis";

const api = apis.accounts.member_monthly_profit;
const STORE_UPDATE = "pages/accounts/memberMonthlyProfit/update";

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDateSearch,
    TgTable,
    TgBetContent,
    ThirdPartyPublicBetContent,
    ThirdPartySabaBetContent,
    TgBetId,
    ThirdPartyCheckBoxDialog,
    ThirdPartySearchBtn,
    ThirdPartyPlatform,
  },

  mixins: [sabaParlayHandler, thirdPartyCheckBoxDialogHandler],
  data() {
    return {
      dateRange: {
        startDate: "",
        endDate: "",
      },
      columns: [],
      proxy: api.getDetail,
      searchData: {
        targetName: "",
      },
      third_party: [],
      amountPageData: {},
      init: false,
      amountData: {},
    };
  },
  created() {
    if (this.$route.params && this.$route.params.third_party != undefined) {
      this.third_party = [this.$route.params.third_party];
      this.searchData.third_party = this.third_party.map((r) => {
        return r.platform;
      });
    }

    const nameFromQuery = this.$route.query.targetName;
    this.$store.commit("breadcrumb/add", {
      name: "member_monthly_profit",
      query: {
        ...this.$route.query,
      },
      path: this.$route.path,
      meta: {
        title: `${nameFromQuery} ${this.$t("component.label.detail")}`,
      },
    });

    api.getColumns().then((response) => {
      this.columns = response.data.detail;

      this.$nextTick(() => {
        this.handleSearch();
      });
    });
  },
  computed: {
    thirdPartyData: {
      get() {
        return this.$store.state.pages.accounts.memberMonthlyProfit
          .thirdPartyData;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { thirdPartyData: val });
      },
    },
  },
  methods: {
    getSubmitValidate() {
      const dateFromQuery = this.$route.query.date;
      const nameFromQuery = this.$route.query.targetName;
      if (!dateFromQuery && !nameFromQuery) {
        this.$router.push({ name: "accounts.member_monthly_profit.index" });
        return;
      }

      this.searchData.targetName = nameFromQuery;

      this.dateRange.startDate = dateFromQuery
        ? this.getMonthStartDate(dateFromQuery)
        : this.dateRange.startDate;
      this.dateRange.endDate = dateFromQuery
        ? this.getMonthEndDate(dateFromQuery)
        : this.dateRange.endDate;

      const params = {
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        ...this.searchData,
        third_party:
          this.thirdPartyData?.map((item) =>
            item.platform ? item.platform : item.key
          ) || [],
      };
      return params;
    },
    async handleSearch() {
      const params = await this.getSubmitValidate();
      this.$nextTick(() => {
        this.$refs.table.search(params);
      });
    },
    clickToSearch() {
      const nameFromQuery = this.$route.query.targetName;
      this.$router.push({
        query: {
          date: "",
          targetName: nameFromQuery,
        },
      });
      this.handleSearch();
    },
    handleLoaded(response) {
      this.amountData = response.amount_data;
    },
    async handleSearchThirdParty(value) {
      this.thirdPartyData = value;
      this.platforms = this.thirdPartyData.map((r) => {
        return r.platform;
      });
      await this.handleSearch();
    },
    getMonthStartDate(month) {
      if (!month) return "";
      const [year, monthNum] = month.split("-");
      return `${year}-${monthNum}-01`;
    },
    getMonthEndDate(month) {
      if (!month) return "";
      const [year, monthNum] = month.split("-");
      const lastDay = new Date(year, monthNum, 0).getDate();
      return `${year}-${monthNum}-${lastDay}`;
    },
    parsePageSummary() {
      let data = this.amountData ? [this.amountData] : [];

      return summary(this.columns, data, this.$t("component.table.summary"), 0);
    },
    formatBetContent(item) {
      if (item.event) {
        item["team1"] = item.event.split(" v ")[0];
        item["team2"] = item.event.split(" v ")[1];
      }
      return item;
    },
  },
};
</script>
